import { Spinner } from 'component-library/components/Feedback/Spinner';
import { PageContainer } from 'component-library/components/Layout/PageContainer';

export const RouteLoader = () => (
  <PageContainer>
    <Spinner size="large" />
  </PageContainer>
);
